import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loader: true,
  loaderText: null,
  legal: {},
  theme: 'default',
  errorPage: {
    notFound: '',
    general: ''
  },
  paginationFilters: {
    perPage: 25,
    sortBy: null,
    sortDesc: true,
    currentPage: 1,
    totalRows: 0
  },
  marks: [],
  models: [],
  bodyStyles: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
